import _ from 'lodash'
import URLSearchParams from '@ungap/url-search-params'

const instanceName = (state = null, action) => {
  switch (action.type) {
    case 'SET_INSTANCE_NAME': {
      const urlQueries = new URLSearchParams(window.location.search)
      const instance = urlQueries.get('instance')
      const tenant = _.get(action, 'app.tenants', []).find(tenant => tenant.url && tenant.url.includes(instance))
      return tenant ? (
        tenant.tenant_display_name || tenant.tenant_instance_name || tenant.serial_number || tenant.tenant_id
      ) : null
    }
    default:
      return state
  }
}

export default instanceName
